export default __webpack_public_path__ + "static/media/607.ff71d130.png";